import chroma from "chroma-js";
const selectStyles = {
  control: (baseStyles) => ({
    ...baseStyles,
    borderColor: "#CED4DA",
    boxShadow: "0 1px 2px 0 #CED4DA",
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontSize: 14,
    fontWeight: 500,
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    fontSize: 13,
    fontWeight: 400,
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    fontSize: 13,
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    fontSize: 14,
    fontWeight: 500,
  }),
  loadingMessage: (baseStyles) => ({
    ...baseStyles,
    fontSize: 13,
    fontWeight: 500,
  }),
};


export const multiSelectStyles = {
  control: (baseStyles) => ({
    ...baseStyles,
    borderColor: "#CED4DA",
    boxShadow: "0 1px 2px 0 #CED4DA",
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontSize: 14,
    fontWeight: 500,
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    fontSize: 13,
    fontWeight: 400,
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    fontSize: 13,
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    fontSize: 14,
    fontWeight: 500,
  }),
  loadingMessage: (baseStyles) => ({
    ...baseStyles,
    fontSize: 13,
    fontWeight: 500,
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor: chroma("green").alpha(0.09).css(),
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: "green",
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
    ":hover": {
      backgroundColor: data.color,
      color: "red",
    },
  }),
};

export default selectStyles;
